import { setTerm } from './helpers';
import { IJsonQuery } from '@cian/api-models/common/json_query';

export const setBuilderId = setTerm(('builder' as unknown) as keyof IJsonQuery);
